import { Injectable } from '@angular/core';
import { LocalStorageService } from '@library/utils/services/local-storage.service';
import { ConsumptionUnit, GraphType } from '@pages/control-page/control-page-store.service';

export interface SidebarCacheDataset {
  homeId: string,
  moduleId?: string,
  roomId?: string,
  graphType?: GraphType,
  selected?: boolean,
  unit?: ConsumptionUnit,
}

interface SidebarCache {
  cards: Record<string, {
    sidebarCardOpen?: boolean
  }>,
  datasets: Record<string, SidebarCacheDataset>
}

@Injectable()
export class ControlPageSidebarCacheService {

  private cache: SidebarCache = JSON.parse(this.localStorage.getItem('sidebar-cache') ?? '{}');

  cards = this.cache.cards ?? {};
  datasets = this.cache.datasets ?? {};

  constructor(
    public localStorage: LocalStorageService,
  ) {}

  getCard(id: string) {
    let card = this.cards[id];

    if (!card) {
      card = this.cards[id] = {};
    }

    return card;
  }

  setDataset(dataset: SidebarCacheDataset) {
    this.datasets[dataset.homeId] = dataset;
    this.save();
  }

  save() {
    this.localStorage.setItem('sidebar-cache', JSON.stringify({cards: this.cards, datasets: this.datasets}));
  }
}
